import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { LogsClassificationComponent } from "../../components/logsClassifcation"

export const LogsClassificationPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <LogsClassificationComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}